import { useRouter } from "next/router";
import { useIntl } from "react-intl";

const Breadcrumbs = ({ currentPage, className = '' }) => {
    const intl = useIntl();
    const router = useRouter();

    const goHome = () => {
        router.push("/");
    };

    return (
        <div className={'breadcrumbs-wrapper'}>
            <ul className={`breadcrumbs ${className}`}>
                <li>
                    <a href="#" onClick={goHome}>
                        {intl.messages.home}
                    </a>
                </li>
                <li>
                    <span>{currentPage}</span>
                </li>
            </ul>
        </div>
    )
}

export default Breadcrumbs